// components/BusinessRoutes.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const BusinessRoutes = ({ children }) => {
  const { userInfo } = useSelector((state) => state.userLogin);

  if (!userInfo) return <Navigate to="/login" replace />;
  if (userInfo.profile !== "Business") return <Navigate to="/" replace />;

  return children;
};

export default BusinessRoutes;
